import React, { useEffect, useState } from 'react';
import { array, bool, number, object } from 'prop-types';

import { connect } from 'react-redux';

import { find, get, isEmpty, cloneDeep } from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';

import AutoComplete from '../../../components/FormFields/Autocomplete';

import * as CoreActions from '../../../actions/coreActions';
import * as WizardActions from '../../../actions/wizardActions';

import classes from './WizardStep.module.css';

const ValidationSchema = Yup.object().shape({
    agent: Yup.string().required()
});

const AgentStep = ({
    agents,
    companyInfo,
    fetchProfilesByAgent,
    resetFromStepOne,
    selectedSite,
    setProgressBarLoading,
    setTargetAgent,
    setValidateForm,
    targetAgent,
    validateForm,
    ...props
}) => {
    const [targetAgents, setTargetAgents] = useState([]);

    useEffect(() => {
        if (validateForm) {
            formik.handleSubmit();

            setValidateForm(false);
        }
    }, [validateForm]);

    useEffect(() => {
        convertAgents();
    },[agents]);

    const formik = useFormik({
        initialValues: {
            agent: targetAgent
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                activeStep,
                setActiveStep,
                setAgentName
            } = props;

            setAgentName(targetAgent.name);
            setActiveStep(activeStep + 1);
        }
    });

    const convertAgents = () => {
        const siteNotNull = cloneDeep(agents.filter(a => a.site !== undefined && a.site !== null));
        const filteredAgents = siteNotNull.filter(s => {
            if (s.site?.find(site => site.id === selectedSite.id)) {
                return true;
            }
            else {
                return false;
            }
        });
        
        const transformedAgents = [
            {
                items:     [...Object.values(filteredAgents)],
                name:      'Agents',
                itemProps: {
                    type: 'agents'
                }
            }
        ];

        setTargetAgents(transformedAgents);
    };

    const handleAgentSelect = async event => {
        resetFromStepOne();
        setProgressBarLoading(true);

        const { value } = event.target;

        if (isEmpty(value)) {
            formik.handleChange(event);
            setProgressBarLoading(false);

            return;
        }

        const targetAgent = find(agents, agent => agent.id === value.id);
        const agentId = get(value, 'id');
        const basType = get(value, 'driverConfiguration[0].basType', '');
        const configurationId = get(value, 'driverConfiguration[0].id', '');

        setTargetAgent(targetAgent);

        formik.handleChange(event);

        let isFetched = await fetchProfilesByAgent(agentId, basType, companyInfo.companyId, configurationId);

        if (isFetched) {
            setProgressBarLoading(false);
        }
    };

    return (
        <div className={classes.wizardForm}>
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/generalNetworkSettingsIconColor.svg" alt="Agent Icon" />
                        <span>Target Agent</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            The Agent selected will be used to generate a list of Profiles available for Equipment and Sensor creation.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <AutoComplete
                                grouped
                                label="Agent"
                                name="agent"
                                onBlur={formik.handleBlur}
                                onChange={handleAgentSelect}
                                options={targetAgents}
                                placeholder="Agent"
                                value={formik.values.agent}
                                error={Boolean(formik.errors.agent) && Boolean(formik.touched.agent)}
                                helperText={Boolean(formik.touched.agent) && formik.errors.agent}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        </div>
    );
};

AgentStep.defaultProps = {
    activeStep:   0,
    agents:       [],
    companyInfo:  {},
    targetAgent:  {},
    validateForm: false
};

AgentStep.propTypes = {
    activeStep:   number,
    agents:       array,
    companyInfo:  object,
    targetAgent:  object,
    validateForm: bool
};

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents } = basAgent;

    return {
        activeStep:   state.wizard.activeStep,
        agents:       Object.values(basAgents),
        companyInfo:  state.companyInfo,
        targetAgent:  state.wizard.targetAgent,
        validateForm: state.wizard.validateForm
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentStep);
